var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4534886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99234 12.3624H4.97405C4.55453 12.3624 4.35209 12.1593 4.36429 11.7495C4.39234 10.2844 5.54111 8.98125 7.01185 8.79992C7.75993 8.6876 8.52197 8.70437 9.26429 8.84949C9.93755 9.0129 10.5365 9.39442 10.9662 9.93356C11.3959 10.4727 11.6317 11.1386 11.6362 11.8257C11.6385 11.8974 11.6258 11.9688 11.5989 12.0354C11.572 12.102 11.5316 12.1624 11.48 12.2128C11.4285 12.2632 11.3671 12.3025 11.2995 12.3282C11.232 12.354 11.1598 12.3656 11.0875 12.3624C10.6375 12.3624 10.1875 12.3624 9.73624 12.3624H7.99234Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.81836 5.80344C5.82115 5.37253 5.95148 4.95209 6.19291 4.59516C6.43434 4.23822 6.77607 3.96077 7.17499 3.7978C7.5739 3.63482 8.01215 3.59363 8.43445 3.6794C8.85675 3.76518 9.24419 3.97407 9.54791 4.27976C9.85164 4.58545 10.058 4.97424 10.1411 5.39708C10.2241 5.81992 10.1801 6.25788 10.0146 6.65573C9.84902 7.05359 9.56938 7.39351 9.21089 7.63263C8.8524 7.87176 8.43112 7.99937 8.0002 7.99938C7.41993 7.99666 6.86441 7.76398 6.45542 7.35235C6.04643 6.94071 5.81734 6.38371 5.81836 5.80344V5.80344Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 128",
    cx: 8,
    cy: 8,
    r: 7.4,
    stroke: "currentColor",
    strokeWidth: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.417c16da.svg";
export { ForwardRef as ReactComponent };